import { JobType } from '../../constants';
import { createTableSlice } from '../helpers';

export const tableSlice = createTableSlice({
  name: 'automatedJobs/preprocessingTable',
  url: '/api/jobs',
  filters: {
    type: JobType.PREPROCESSING,
  },
  sortOrder: 'desc',
  orderBy: 'id',
});
